import { renderToolBlockInstance } from "../../shared/SimulatorWrapper/SimulatorWrapper";
import { forms } from "./Form/Form";
import Results from "./Results/Results";

const TOOL_KEY = "quote_equity";

renderToolBlockInstance({
  toolKey: TOOL_KEY,
  formConfig: forms[TOOL_KEY],
  Results,
});
